import { Directive } from '@angular/core';

@Directive({
    selector: '[pPageActionsDef]',
})
export class PageActionsDefDirective {}
